export default __webpack_public_path__ + "static/media/Lilith_Black.1a524d09.png";